import { jsx as _jsx } from "react/jsx-runtime";
import ErrorBoundary from '@helsenorge/framework-utils/components/error-boundary';
import ErrorMessage from '../error-message';
import { Projects, useResources } from '../resources';
import defaultResources from '../resources/HN.Core.Framework.NPM.JS.nb-NO.json';
const ErrorBoundaryWrapper = (props) => {
    const resources = useResources(Projects.FRAMEWORK);
    return (_jsx(ErrorBoundary, { renderFallback: args => (_jsx(ErrorMessage, { label: resources?.unknownError || defaultResources.unknownError, description: resources?.unknownErrorAction || defaultResources.unknownErrorAction, correlationId: args.correlationId, debugTitle: args.name, debugText: args.message })), children: props.children }));
};
export default ErrorBoundaryWrapper;
